var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
		selected: _vm.selected
	},attrs:{"name":_vm.name},on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }